export default [
    {
		path: '/leaderboard',
		name: 'Leaderboard',
		component: () => import('@/views/leaderboard/Leaderboard.vue'),
        meta: {
			layout: 'Default',
            abilities: [['view', 'workspace-schedules']],
            nav: 'leaderboard',
		}
	},
]